import { boot } from 'quasar/wrappers'
import extensionIcon from '../functions/extension-icon'

export default boot(({ app }) => {
	app.config.globalProperties.$extensionIcon = extensionIcon
})
